import React from "react";
import { HtmlInputTypes, NotificationTypes, objects } from "./constants";
import { IoDocumentText } from "react-icons/io5";
import { FaUserTie } from "react-icons/fa";
import {
  CastForEducationRounded,
  EventAvailableRounded,
} from "@material-ui/icons";

// Services
import * as loginService from "../../services/Login";

export const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const prepareGradeApplicationForm = async (
  values,
  criteriaQuestions
) => {
  try {
    const form = {};
    const multiFileInputTypes = criteriaQuestions.filter(
      (q) => q.htmlType === HtmlInputTypes.FILES
    );
    const singleFileInputTypes = criteriaQuestions.filter(
      (q) => q.htmlType === HtmlInputTypes.FILE
    );
    const facilityGroupInputTypes = criteriaQuestions.filter(
      (q) => q.htmlType === HtmlInputTypes.FACILITY_GROUP
    );

    for (const [key, value] of Object.entries(values)) {
      if (value !== undefined) {
        const formFieldWithMultiFileInputType = multiFileInputTypes.findIndex(
          (q) => q._id === key
        );
        const formFieldWithSingleFileInputType = singleFileInputTypes.findIndex(
          (q) => q._id === key
        );
        const formFieldWithFacilityGroupInputType = facilityGroupInputTypes.findIndex(
          (q) => q._id === key
        );

        if (formFieldWithMultiFileInputType > -1 && value[0] instanceof File) {
          const files = [];
          for (let item of value) {
            const base64File = await convertFileToBase64(item);
            files.push({
              base64: base64File,
              MimeType: item.type,
              FileName: item.name,
            });
          }
          form[key] = files;
          continue;
        } else if (
          formFieldWithSingleFileInputType > -1 &&
          value instanceof File
        ) {
          const base64File = await convertFileToBase64(value);
          form[key] = {
            base64: base64File,
            MimeType: value.type,
            FileName: value.name,
          };
          continue;
        } else if (formFieldWithFacilityGroupInputType > -1 && value.length) {
          for (let i = 0; i < value.length; ++i) {
            for (let j = 0; j < value[i].photoes.length; ++j) {
              const base64File = await convertFileToBase64(value[i].photoes[j]);
              value[i].photoes[j] = {
                base64: base64File,
                mimeType: value[i].photoes[j].type,
                name: value[i].photoes[j].name,
              };
            }
          }
        }
      }

      form[key] = value;
    }

    return form;
  } catch (err) {
    console.log(err);
  }
};

export const prepareStaticAppForm = async (
  stakeholderData,
  registrationData,
  status,
  existVoen,
  editable = true,
  selectedIndustryCategory
) => {
  try {
    const staticForm = {};
    let form = "";

    for (const [key, value] of Object.entries(registrationData)) {
      if (editable) {
        if (
          selectedIndustryCategory?.name?.az === "Bələdçilər".toLowerCase() &&
          (key === "managerPosition" ||
            key === "personInChargePosition" ||
            key === "voenDateOfRegistration" ||
            key === "objectStartDateOfOperation" ||
            key === "website")
        ) {
          staticForm[key] = undefined;
          continue;
        }

        // if (selectedIndustryCategory?.name?.az !== "Bələdçilər".toLowerCase()  && (key === 'confirmationDocument')) {
        //   staticForm[key] = undefined;
        //   continue;
        // };

        // if (selectedIndustryCategory?.name?.az !== "Bələdçilər".toLowerCase()) { //&& (key === 'optionalActionCodes')
        //   // staticForm[key] = value.split(',');
        //   continue;
        // };
      }

      if (key === "photo" && value.length > 0) {
        // let valuesPhoto = [];
        // // for (const key in value) {
        // //   // if (Object.hasOwnProperty.call(object, key)) {
        // //     valuesPhoto.push(value[key]);

        // //   // }
        // // }
        // // console.log(valuesPhoto)
        let files = [];
        for (let item of value) {
          if (!item.hasOwnProperty("url")) {
            const base64File = await convertFileToBase64(item);

            files.push({
              base64: base64File,
              MimeType: item.type,
              FileName: item.name,
            });
          } else {
            files.push(item);
          }
        }

        staticForm[key] = files;

        continue;
      }

      if (key !== "photo") {
        staticForm[key] = value;
      }
    }

    if (status === "PUT") {
      form = staticForm;
    } else {
      form = { ...staticForm, ...stakeholderData };
    }
    return form;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const fetchObjectCodes = () => {
  let objectCodes = [];
  objects.map((item) => objectCodes.push(item.objectCode));
  return objectCodes;
};

// export const checkObjects = async(selectedVoen) => {
//   let getObjectCodes = fetchObjectCodes();
//   return (await loginService.checkObject(selectedVoen, getObjectCodes));
// };

export const getObjects = async (selectedVoen) => {
  return await loginService.getObject(selectedVoen);
};
// export const prepareQuestionaryForm = async(answers) => {
//    const answerForm = {};

//    for (const [key, value] of Object.entries(answers)) {
//     if(value?.file) {
//       const documentFile = {};
//       const base64File = await convertFileToBase64(value?.file);

//       file["base64"] = base64File;
//       file["MimeType"] = value?.file?.type.split('/')[1];
//       file["FileName"] = value?.file?.name;

//       answerForm[key] = documentFile;
//       continue;
//     };

//     answerForm[key] = value;
//   };

// }

export const getIconByNotificationType = {
  [NotificationTypes.Stakeholder]: (
    <FaUserTie style={{ fontSize: 24, color: "#8950fc" }} />
  ),
  [NotificationTypes.GradeApplication]: (
    <IoDocumentText style={{ fontSize: 24, color: "#1682c0" }} />
  ),
  [NotificationTypes.Event]: (
    <EventAvailableRounded style={{ fontSize: 24, color: "#ffa800" }} />
  ),
  [NotificationTypes.Training]: (
    <CastForEducationRounded style={{ fontSize: 24, color: "forestgreen" }} />
  ),
};

export const getUrlParamByName = (name = "") => {
  try {
    if (!name) {
      return undefined;
    }
    const searchUrl = window?.location?.search || "";
    const searchParams = new URLSearchParams(searchUrl);
    const result = searchParams.get(name);
    return result;
  } catch (error) {
    console.error("getUrlParamByName error: ", error);
    return undefined;
  }
};
